module.exports = __webpack_public_path__ + "img/jiandingbao.28302b3c.jpg";